import React from 'react';
import './SubmitInfoMessage.css';

export default function SubmitInfoMessage({ formInfo, closeModal }) {
  const { formType, formSubmissionAccepted } = formInfo.workOrder;
  return (
    <div className="submit-info-container">
      {formSubmissionAccepted
        ? `Uspješno ste ${
            formType === 'open' ? 'otvorili' : 'zatvorili'
          } radni nalog.`
        : `Trenutno nije moguće izvršiti ${
            formType === 'open' ? 'otvaranje' : 'zatvaranje'
          }  radnog naloga.`}
      <button
        type="submit"
        className="submit-info-close-button"
        onClick={closeModal}
      >
        Zatvori
      </button>
    </div>
  );
}
